(function () {

  'use strict';

  function pxTooltip($timeout, $document) {
    return {
      restrict: 'EA',
      scope: {
        tooltipObject: '=tooltipObject',
        tooltipContent: '=tooltipContent',
      },
      templateUrl: 'app/directives/tooltip/tooltip.template.html',
      link: function (scope, element) {

        let tooltip = new Tooltip(scope.tooltipObject);
        tooltip.init();

        function Tooltip(tooltipObject) {
          this.left = tooltipObject.position.left;
          this.top = tooltipObject.position.top;
          this.forceCenter = false;
          this.contextMenu = tooltipObject.contextMenu ? tooltipObject.contextMenu : false;
          this.width = null;
          this.height = null;
          this.viewWidth = window.innerWidth;
          this.viewHeight = window.innerHeight;
          this.container = null;
          this.parentContainer = null;
          this.exceptionContainer = null;

          this.setHorizontalPosition = () => {
            if (this.exceptionContainer) {
              this.forceCenter = true;
              this.container.style.left = `${this.left - (this.width / 2)}px`;
            } else {
              if ((this.left + this.width) > this.viewWidth) {
                this.container.style.left = `${this.left - this.width + 15}px`;
              } else {
                this.container.style.left = `${this.left}px`;
              }
            }
          };

          this.setVerticalPosition = () => {
            if ((this.top + this.height) > this.viewHeight) {
              this.container.style.top = `${this.top - (this.height + 30)}px`;
            } else {
              this.container.style.top = `${this.top}px`;
            }
          };

          this.showTooltip = () => {
            this.container.style.opacity = 1;
          };

          this.hideTooltip = () => {
            this.container.style.opacity = 0;
          };

          this.setWidth = () => {
            this.width = this.container.getBoundingClientRect().width;
          };

          this.setHeight = () => {
            this.height = this.container.getBoundingClientRect().height;
          };

          this.trackTooltip = () => {
            let that = this;
            $document.on('mousemove', function (event) {
              const parentOffsetLeft = that.parentContainer?.offsetLeft ?? 0;
              const parentOffsetTop = that.parentContainer?.offsetTop ?? 0;
              if (that.contextMenu && that.forceCenter) {
                that.left = event.clientX - parentOffsetLeft;
                that.top = event.clientY + 20 - parentOffsetTop;
              } else if (that.contextMenu && !that.forceCenter) {
                that.left = event.clientX - 15 - parentOffsetLeft;
                that.top = event.clientY + 20 - parentOffsetTop;
              } else if (!that.contextMenu && that.forceCenter) {
                that.left = event.clientX;
                that.top = event.clientY + 20;
              } else {
                that.left = event.clientX - 15;
                that.top = event.clientY + 20;
              }
              that.setHorizontalPosition();
              that.setVerticalPosition();
            });
          };

          this.setElements = () => {
            this.container = document.querySelector('.px-tooltip');
            if (this.contextMenu) {
              this.parentContainer = angular.element('.context-content-container')[0] ??
                angular.element('.context-content-container-alt')[0];
            }
            this.exceptionContainer = document.querySelector('.px-tooltip-solo');
            if (!this.container) {
              $timeout(() => {
                this.setElements()
              }, 10);
            } else {
              this.hideTooltip();
              this.setWidth();
              this.setHeight();
              this.setHorizontalPosition();
              this.setVerticalPosition();
              this.trackTooltip();
              this.showTooltip();
            }
          };

          this.init = () => {
            this.setElements();
          };
        }

        scope.$on('$destroy', function () {
          $document.off('mousemove');
          tooltip = null;
        });

      }
    };
  }

  pxTooltip.$inject = ['$timeout', '$document'];

  angular
    .module('printix-admin')
    .directive('pxTooltip', pxTooltip);

})();
